var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"date-time-label"},[_vm._v(_vm._s(_vm._f("dateTimeFilter")(this.value,{ format: _vm.format, timeZone: _vm.timeZone })))])}
var staticRenderFns = []

export { render, staticRenderFns }